// Gmail-style draft storage for the Estimated Quotation form.
//
// The form lives inside a popup on the Estimated Quotations page, so leaving
// that page used to throw the typed data away. We now mirror the form into
// localStorage on every change, so it survives page changes and refreshes,
// and a floating "draft" bar (rendered in AdminLayout) lets the user resume.
//
// Draft shape: { form, editingId, open, updatedAt }
//   open = true  → the popup is currently open on the quotations page
//   open = false → minimized / closed (the bar offers "Resume")

const KEY = "uee_quotation_draft_v1";
export const DRAFT_EVENT = "uee-qdraft-change";
export const DRAFT_RESUME_EVENT = "uee-qdraft-resume";

export function loadDraft() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const d = JSON.parse(raw);
    return d && d.form ? d : null;
  } catch (e) {
    return null;
  }
}

export function saveDraft(draft) {
  try {
    localStorage.setItem(KEY, JSON.stringify({ ...draft, updatedAt: Date.now() }));
    window.dispatchEvent(new Event(DRAFT_EVENT));
  } catch (e) {
    /* storage full / blocked — draft just won't persist */
  }
}

export function clearDraft() {
  try {
    localStorage.removeItem(KEY);
    window.dispatchEvent(new Event(DRAFT_EVENT));
  } catch (e) {
    /* ignore */
  }
}